import { ComponentPropsWithoutRef } from 'react';

export const VoteButton = ({ children, ...rest }: ComponentPropsWithoutRef<'a'>) => {
  return (
    <a
      className="min-h-[30px]items-center ml-4 inline-block w-full scale-100 rounded-[18px] bg-black px-4
      py-1 text-center text-xs uppercase leading-4 tracking-[0.04rem] text-mglGray50 no-underline shadow-[0_0_0_0_rgba(0,_0,_0,_1)]
      transition-all duration-200 ease-ease tablet:px-4 tablet:py-2 tablet:text-sm tablet:leading-5 desktop:w-[initial] desktop:px-8 desktop:py-2 [&_strong]:flex
      [&_strong]:justify-center [&_strong]:text-center [&_strong]:text-xs [&_strong]:font-medium
      [&_strong]:uppercase [&_strong]:leading-4 [&_strong]:tracking-[0.04rem] [&_strong]:no-underline tablet:[&_strong]:text-sm tablet:[&_strong]:leading-5"
      {...rest}>
      {children}
    </a>
  );
};
